import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-event-training-dialog',
  imports: [
    CommonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './event-training-dialog.dialog.html',
  styleUrl: './event-training-dialog.dialog.scss'
})
export class EventTrainingDialogDialog {
  private matDialogref = inject(MatDialogRef<EventTrainingDialogDialog>);
  private router = inject(Router);
  private intervalId: any;

  current = 0;
  cards = [
     {
      title: 'Card 1',
      subtitle: 'View',
      image: 'assets/images/events/image013.png',
      sectionId: 'T-1'
    },
     {
      title: 'Card 2',
      subtitle: 'View',
      image: 'assets/images/events/image014.jpg',
      sectionId: 'T-2'
    },
    {
      title: 'Card 3',
      subtitle: 'View',
      image: 'assets/images/events/image4.png',
      sectionId: 'T-3'
    },
  ];

  get total() {
    return this.cards.length;
  }

  // Moves the carousel forward (1) or backward (-1), wrapping around.
  // Also restarts the autoslide timer so a manual move doesn't get
  // immediately overridden by a pending auto-advance.
  move(direction: number): void {
    const total = this.total;
    if (total === 0) return;
    this.current = (this.current + direction + total) % total;
    this.restartAutoSlide();
  }

  // Used by the dots: jump straight to index i
  getTo(i: number): void {
    if (i < 0 || i >= this.total) return;
    this.current = i;
    this.restartAutoSlide();
  }

  getPosition(i: number): string {
    const total = this.total;
    if (total === 0) return '';

    let diff = i - this.current;

    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    if (diff === 0) return 'pos-active';
    if (diff === 1) return 'pos-right';
    if (diff === -1) return 'pos-left';
    if (diff > 1) return 'pos-far-right';
    return 'pos-far-left';
  }

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
  }

  startAutoSlide(): void {
    this.stopAutoSlide();
    this.intervalId = setInterval(() => {
      this.current = (this.current + 1) % this.total;
    }, 5000);
  }

  stopAutoSlide(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  // Restarts the timer on manual interaction so auto-advance doesn't
  // fire right after the user just moved the carousel themselves
  private restartAutoSlide(): void {
    this.startAutoSlide();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.move(-1);
    if (event.key === 'ArrowRight') this.move(1);
  }

  // Clicking a side card brings it to center; clicking the already
  // centered card scrolls to its linked section
  goToNavigate(i: number): void {
    if (i < 0 || i >= this.total) return;

    this.current = i;
    this.restartAutoSlide();

    const card = this.cards[i];
    if (!card || !card.sectionId) return;

    const el = document.getElementById(card.sectionId);
    el?.scrollIntoView({ behavior: 'smooth' });
    this.matDialogref.close();
    this.router.navigate(['/events-training']);
  }

  navigate() {
    this.matDialogref.close();
    this.router.navigate(['/events-training']);
  }
}